async function parse(r) {
  const data = await r.json().catch(() => ({}))
  if (!r.ok || data.success === false) {
    const extra = Array.isArray(data.detail) ? ` — ${data.detail.join('; ')}` : (data.detail ? ` — ${data.detail}` : '')
    throw new Error((data.error || data.message || `Request failed (${r.status})`) + extra)
  }
  return data
}

export function ioGet(path) {
  return fetch(path, { credentials: 'include', cache: 'no-store' }).then(parse)
}

export function ioSend(path, method, body) {
  return fetch(path, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body != null ? JSON.stringify(body) : undefined,
  }).then(parse)
}

export function ioSendForm(path, formData) {
  return fetch(path, { method: 'POST', credentials: 'include', body: formData }).then(parse)
}
